import { all, fork } from 'redux-saga/effects'
import appSaga from '~/views/redux/sagas/index'

export default function* rootSaga() {
  yield all([fork(appSaga)])
}
